var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-tooltip',{attrs:{"text":"Aantal besteld"}},[_c('div',{staticClass:"text-3xl inline-block"},[_vm._v(_vm._s(this.quantity))]),_c('div',{staticClass:"text-xl inline-block"},[_vm._v("x")])])}
var staticRenderFns = []

export { render, staticRenderFns }